import { getEnvironment } from "./environments";

const getEnvironmentPrefix = (): string => {
  const env = getEnvironment();

  switch (env) {
    case "local":
      return "🟢 [local] ";
    case "preview":
      return "🟡 [preview] ";
    case "production":
    default:
      return "";
  }
};

export const siteConfig = {
  name: `${getEnvironmentPrefix()}CrowdSec Kickstart`,
  description:
    "Interactive cybersecurity onboarding platform. Get personalized security recommendations and strengthen your infrastructure with CrowdSec's collaborative threat intelligence.",
  navItems: [
    {
      label: "Website",
      href: "https://crowdsec.net",
      external: true,
    },
    {
      label: "Console",
      href: "https://app.crowdsec.net",
      external: true,
    },
    {
      label: "Docs",
      href: "https://doc.crowdsec.net",
      external: true,
    },
    {
      label: "Pricing",
      href: "https://crowdsec.net/pricing",
      external: true,
    },
    {
      label: "Blog",
      href: "https://crowdsec.net/blog",
      external: true,
    },
  ],
  navMenuItems: [
    {
      label: "Profile",
      href: "/profile",
    },
    {
      label: "Dashboard",
      href: "/dashboard",
    },
    {
      label: "Projects",
      href: "/projects",
    },
    {
      label: "Team",
      href: "/team",
    },
    {
      label: "Calendar",
      href: "/calendar",
    },
    {
      label: "Settings",
      href: "/settings",
    },
    {
      label: "Help & Feedback",
      href: "/help-feedback",
    },
    {
      label: "Logout",
      href: "/logout",
    },
  ],
  links: {
    github: "https://github.com/crowdsecurity/crowdsec",
    twitter: "https://twitter.com/crowdsec",
    docs: "https://doc.crowdsec.net",
    discord: "https://discord.gg/crowdsec",
  },
};
